<script>
import { SvgToVueCompiler } from '@/common/util/templateCompiler'

/**
 * Make SVG a component and to allow adding reactive attributes.
 * It also set the right role to svg element and its descendant for ARIA.
 *
 * @since KJS-5014
 */
export default {
  name: 'SvgImage',
  props: {
    template: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: null
    },
    decorative: {
      type: Boolean,
      default: true
    }
  },
  render($createElement) {
    if (!this.template) return ''

    const setAriaLabel = !(
      this.$attrs['aria-label'] || this.$attrs['aria-labelledby']
    )

    const compiler = new SvgToVueCompiler($createElement)
    return compiler.render(this.template, {
      title: this.title,
      decorative: this.decorative,
      setAriaLabel
    })
  }
}
</script>
